import React, { useEffect } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import './App.css';
import AppRouter from './routes/AppRouter';
import { initGA } from './components/Analytics';

function App() {
  useEffect(() => {
    initGA();

    // Scroll Progress Bar
    const updateScrollProgress = () => {
      const scrolled = window.pageYOffset;
      const maxHeight = document.documentElement.scrollHeight - window.innerHeight;
      const scrollProgress = (scrolled / maxHeight) * 100;
      
      const progressBar = document.querySelector('.scroll-progress');
      if (progressBar) {
        progressBar.style.width = `${scrollProgress}%`;
      }
    };

    // Event listeners
    window.addEventListener('scroll', updateScrollProgress);

    // Cleanup
    return () => {
      window.removeEventListener('scroll', updateScrollProgress);
    };
  }, []);

  return (
    <Router>
      <div className='App'>
        {/* Barra de progreso de scroll */}
        <div className="scroll-progress"></div>

        <div className="app-content">
          <AppRouter />
        </div>
      </div>
    </Router>
  );
}

export default App;
